import React, {useContext} from "react";
import ThemeContext from "../Theme/ThemeContext";

export type ScoreData = ScoreDataPoints | ScoreDataTime | ScoreDataEmpty

export interface ScoreDataEmpty {
    type : "empty-points"
}

export interface ScoreDataPoints {
    type : "points"
    questionNumber : number
    questionCount : number
    score : number
    scoreMax : number
}

export interface ScoreDataTime {
    type : "time"
    time : number
    discovered : number
    total : number
}

export interface ScoreProps {
    data : ScoreData,
    backgroundImage? : string,
    helperImage? : string,
}

export default function Score(props : ScoreProps) {
    const theme = useContext(ThemeContext)

    return <div className="score-component">
        <div className="helper"><img src={props.helperImage ? props.helperImage : theme.helperImage} alt="" /> </div>
        <img src={props.backgroundImage ? props.backgroundImage : ("images/shared/bg-points-" + (props.data.type === "time" ? "memo" : "quiz") + ".png")} alt="" />
        { props.data.type !== "empty-points" &&
            <div className="content">
                <ScoreContent {...props} />
            </div>
        }
    </div>
}

export function ScoreContent(props : ScoreProps) {
    return props.data.type === "empty-points" ? <></> : (props.data.type === "points" ?
            <ScorePoints {...props.data} /> :
            <ScoreTime {...props.data} />)
}

function ScorePoints(props : ScoreDataPoints) {
    return <>
        Zdobyte punkty
        <div className="score-value">{props.score} z {props.scoreMax}</div>
        <div className="question-counter">pytanie {props.questionNumber} z {props.questionCount}</div>
    </>
}

function ScoreTime(props : ScoreDataTime) {
    return <>
        Czas w sekundach
        <div className="score-value">{props.time}</div>
        <div className="question-counter">para {props.discovered} z {props.total}</div>
    </>
}